var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"mt-0 fix-to-top",attrs:{"type":_vm.localType || 'error',"full-width":"","dismissible":"","transition":"fade-transition"},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v("\n  "+_vm._s(_vm.localMessage)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }